import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '@/config/axiosClient';

const url = 'index.php?route=api/order/createOrder';

const ORDER_ERROR_MESSAGE = 'Ocorreu um erro ao criar a encomenda.';

type OrderParams = {
  comment?: string;
  customerId?: number;
  shippingAddressId?: number;
  paymentMethod?: string;
  priceId?: number;
  voucherCode: string;
  voucherAmount: number;
  deliveryDate?: string;
};

type CreateOrderResult = {
  success?: string;
  error?: string | Record<string, string>;
};

const useCreateOrder = () => {
  const { mutateAsync, isLoading } = useMutation(
    async ({
      comment,
      customerId,
      shippingAddressId,
      paymentMethod,
      priceId,
      voucherAmount,
      voucherCode,
      deliveryDate,
    }: OrderParams): Promise<CreateOrderResult> => {
      try {
        const { data } = await axiosInstance.post<CreateOrderResult>(url, {
          comment,
          customerId,
          shippingAddressId,
          paymentMethod,
          priceId,
          voucherAmount,
          voucherCode,
          deliveryDate,
        });

        if (data.error || !data.success) {
          throw new Error(ORDER_ERROR_MESSAGE);
        }

        return data;
      } catch {
        throw new Error(ORDER_ERROR_MESSAGE);
      }
    }
  );

  return { createOrder: mutateAsync, isLoading };
};

export default useCreateOrder;
